import { Button } from "primereact/button";
import { Dropdown } from "primereact/dropdown";
import { MultiSelect } from "primereact/multiselect";
import { useEffect, useState } from "react";

const SLQuestionOptions = (props) => {
  const {
    selectedTQ,
    selectedTQIndex,
    skipToQuesOptions,
    selectedTQAnswerOpts,
    setSkipLogicQOptions,
    skipLogicQOptions,
    onDeleteSkipLogic,
    deleteSlLoading,
  } = props;

  const [validTQAnswerOpts, setValidTQAnswerOpts] = useState([]);
  const [duplicateErrorIndex, setDuplicateErrorIndex] = useState(null); // Tracks duplicate row

  // Initialize skip logic only when selectedTQ changes
  useEffect(() => {
    if (selectedTQ?.skipLogic?.length) {
      setSkipLogicQOptions(selectedTQ.skipLogic);
    }
  }, [selectedTQ]);

  // Update validTQAnswerOpts when answer options change
  useEffect(() => {
    if (selectedTQ?.selectedQuestionOption === "rating_question") {
      const length =
        selectedTQ?.rating_question?.selectedScale === "5" ? 5 : 10;
      const tqOptions = Array.from({ length }, (_, i) => ({
        label: `${i + 1}`,
        value: i + 1,
        optionIndex: i + 1,
        isOptional: true,
      }));
      setValidTQAnswerOpts(tqOptions);

      if (!selectedTQ?.skipLogic?.length && skipLogicQOptions.length === 0) {
        setSkipLogicQOptions([
          {
            selectedOptions: [1],
            skipToQuestionId: null,
            ui: tqOptions[0],
          },
        ]);
      }
    } else {
      let tqOptions = selectedTQAnswerOpts.filter(
        (opt) => !opt.isOptional || opt.value !== "",
      );
      tqOptions = tqOptions.map((TQOption, i) => ({
        ...TQOption,
        optionIndex: i,
      }));

      setValidTQAnswerOpts(tqOptions);

      if (!selectedTQ?.skipLogic?.length && skipLogicQOptions.length === 0) {
        const mandatoryOptions = tqOptions.filter((opt) => !opt.isOptional);
        setSkipLogicQOptions([mandatoryOptions[0]]);
      }
    }
  }, [
    selectedTQAnswerOpts,
    selectedTQ?.selectedQuestionOption,
    selectedTQ?.rating_question?.selectedScale,
  ]);

  // Determine if current selection is duplicate
  useEffect(() => {
    let duplicateIndex = null;

    skipLogicQOptions.forEach((sl, i) => {
      const others = getSelectedOptionsExcludingIndex(i);
      if (sl?.selectedOptions?.some((opt) => others.includes(opt))) {
        duplicateIndex = i;
      }
    });

    setDuplicateErrorIndex(duplicateIndex);
  }, [skipLogicQOptions]);

  // Get all selected options across all skip logic rules except current index
  const getSelectedOptionsExcludingIndex = (currentIndex) => {
    let allSelected = [];
    skipLogicQOptions.forEach((sl, i) => {
      if (i !== currentIndex && sl?.selectedOptions?.length) {
        allSelected = [...allSelected, ...sl?.selectedOptions];
      }
    });
    return allSelected;
  };

  const addMoreSLOptions = () => {
    const getAddOption = validTQAnswerOpts.find(
      (_, index) => index === skipLogicQOptions.length,
    );
    if (!getAddOption) return;
    setSkipLogicQOptions((prevProps) => [
      ...prevProps,
      selectedTQ?.selectedQuestionOption === "rating_question"
        ? { selectedOptions: [], skipToQuestionId: null, ui: getAddOption }
        : getAddOption,
    ]);
  };

  const handleRemoveSkipLogicOption = (index, skipLogicOption) => {
    if (index === 0) {
      const getUpdatedItems = skipLogicQOptions.map((data, i) => {
        if (i === index) {
          return {
            ...data,
            selectedOptions: [],
            skipToQuestionId: null,
            selectedRank: null,
          };
        }
        return { ...data };
      });
      setSkipLogicQOptions(getUpdatedItems);
      setDuplicateErrorIndex(null);
    } else {
      const getUpdatedItems = skipLogicQOptions.filter(
        (_data, i) => i !== index,
      );
      setSkipLogicQOptions(getUpdatedItems);
      setDuplicateErrorIndex(null);
    }
  };

  const handleOnChangeSkipLogicOptValue = (changeProp, propValue, index) => {
    setSkipLogicQOptions((prevProps) =>
      prevProps.map((prevProp, i) => {
        if (i === index) {
          return { ...prevProp, [changeProp]: propValue };
        }
        return prevProp;
      }),
    );
  };

  const handleDeleteSkipLogic = async (skipLogicId, index, skipLogicOption) => {
    const result = await onDeleteSkipLogic(skipLogicId);

    if (result.success) {
      handleRemoveSkipLogicOption(index, skipLogicOption);
      console.log("Success:", result.message);
    } else {
      console.error("Error:", result.message);
    }
  };

  return (
    <div>
      {skipLogicQOptions.length > 0
        ? skipLogicQOptions.map((skipLogicOption, index) => {
            const alreadySelected = getSelectedOptionsExcludingIndex(index);

            // Determine if current selection is duplicate //commented due to infinite loop error & wrong react pattern
            // const hasDuplicate = skipLogicOption.selectedOptions?.some((opt) =>
            //   alreadySelected.includes(opt),
            // );
            // if (hasDuplicate) setDuplicateErrorIndex(index);

            // Filter dropdown/multi-select options to remove already selected
            const availableOptions = validTQAnswerOpts.filter(
              (opt) => !alreadySelected.includes(opt.optionIndex),
            );

            return (
              <div className={`row ${index === 0 ? "mb-3" : ""}`} key={index}>
                <div className="col-md-4 col-12 mb-1">
                  <label>If option selected:</label>
                  {selectedTQ?.selectedQuestionOption ===
                  "multiple_choice_multi_select" ? (
                    <MultiSelect
                      value={skipLogicOption?.selectedOptions || []}
                      onChange={(e) => {
                        const newSelected = e.value;
                        const duplicateFound = newSelected.some((opt) =>
                          alreadySelected.includes(opt),
                        );
                        if (duplicateFound) {
                          setDuplicateErrorIndex(index);
                        } else {
                          setDuplicateErrorIndex(null);
                        }
                        handleOnChangeSkipLogicOptValue(
                          "selectedOptions",
                          newSelected,
                          index,
                        );
                      }}
                      options={availableOptions}
                      optionLabel="value"
                      optionValue="optionIndex"
                      placeholder="Select Option"
                      className="w-100 inputField modal-dropdown"
                      style={{
                        position: "relative",
                      }}
                      selectAllLabel="Select All"
                      appendTo="self"
                    />
                  ) : (
                    <Dropdown
                      value={
                        skipLogicOption?.selectedOptions
                          ? skipLogicOption?.selectedOptions[0]
                          : ""
                      }
                      onChange={(e) => {
                        if (alreadySelected.includes(e.value)) {
                          setDuplicateErrorIndex(index);
                        } else {
                          setDuplicateErrorIndex(null);
                          handleOnChangeSkipLogicOptValue(
                            "selectedOptions",
                            [e.value],
                            index,
                          );
                        }
                      }}
                      options={availableOptions}
                      optionLabel="value"
                      optionValue="optionIndex"
                      placeholder="Select Option"
                      className="w-100 inputField modal-dropdown"
                      appendTo="self"
                    />
                  )}

                  {duplicateErrorIndex === index && (
                    <div style={{ color: "red", fontSize: 12 }}>
                      Duplicate option selected
                    </div>
                  )}
                </div>

                {selectedTQ?.selectedQuestionOption === "ranking_question" && (
                  <div className="col-md-3 col-12 mb-1">
                    <label>Equals to rank:</label>
                    <Dropdown
                      value={skipLogicOption?.selectedRank || ""}
                      onChange={(e) => {
                        if (alreadySelected.includes(e.value)) {
                          setDuplicateErrorIndex(index);
                        } else {
                          setDuplicateErrorIndex(null);
                          handleOnChangeSkipLogicOptValue(
                            "selectedRank",
                            e.value,
                            index,
                          );
                        }
                      }}
                      options={Array.from(
                        { length: validTQAnswerOpts.length },
                        (_, i) => ({
                          label: `${i + 1}`,
                          value: i + 1,
                        }),
                      )}
                      optionLabel="label"
                      optionValue="value"
                      placeholder="Select Rank"
                      className="w-100 inputField modal-dropdown"
                      appendTo="self"
                    />
                  </div>
                )}

                <div
                  className={`${
                    selectedTQ?.selectedQuestionOption === "ranking_question"
                      ? "col-md-5"
                      : "col-md-8"
                  } col-12 ${
                    index === 0 &&
                    !skipLogicOption?.skipToQuestionId &&
                    skipLogicOption?.selectedOptions?.length === 0
                      ? "mb-3"
                      : ""
                  }`}
                >
                  <label>Skip to:</label>
                  <Dropdown
                    value={skipLogicOption?.skipToQuestionId || ""}
                    onChange={(e) => {
                      const targetValue = e.value;
                      const selectedOption = skipToQuesOptions?.find(
                        (skipLogicQOption, i) =>
                          skipLogicQOption?.skipToQuestionId === targetValue,
                      );
                      setSkipLogicQOptions((prevProps) =>
                        prevProps.map((prevProp, i) => {
                          if (i === index) {
                            return {
                              ...prevProp,
                              ...selectedOption,
                            };
                          }
                          return prevProp;
                        }),
                      );
                    }}
                    options={skipToQuesOptions}
                    optionLabel="name"
                    optionValue="skipToQuestionId"
                    placeholder="Skip To"
                    className="w-100 inputField modal-dropdown"
                    appendTo="self"
                  />
                </div>

                {index !== 0 &&
                (!skipLogicOption?.skipToQuestionId ||
                  !skipLogicOption?.selectedOptions) ? (
                  <div className="text-end">
                    <Button
                      className="bulk-add fw-bold fs-14 px-0"
                      link
                      onClick={() =>
                        handleRemoveSkipLogicOption(index, skipLogicOption)
                      }
                    >
                      - Remove
                    </Button>
                  </div>
                ) : (
                  ""
                )}

                {skipLogicOption?.skipToQuestionId &&
                skipLogicOption?.selectedOptions &&
                skipLogicOption?.selectedOptions?.length ? (
                  <div className="text-end">
                    <Button
                      disabled={deleteSlLoading}
                      className="bulk-add fw-bold fs-14 px-0"
                      link
                      onClick={() => {
                        if (
                          skipLogicOption?.skip_logic_id &&
                          skipLogicOption?.skip_logic_id !== 0
                        ) {
                          handleDeleteSkipLogic(
                            skipLogicOption?.skip_logic_id,
                            index,
                            skipLogicOption,
                          );
                        } else {
                          handleRemoveSkipLogicOption(index, skipLogicOption);
                        }
                      }}
                    >
                      - Remove skip logic
                    </Button>
                  </div>
                ) : (
                  ""
                )}
              </div>
            );
          })
        : ""}
      <div>
        <Button
          className="add-more fw-bold fs-14 px-0 mb-3"
          link
          onClick={addMoreSLOptions}
          disabled={skipLogicQOptions.length === validTQAnswerOpts.length}
        >
          + Add more
        </Button>
      </div>
    </div>
  );
};

export default SLQuestionOptions;
